import {
  Row,
  Drawer,
  Form,
  Spin,
  Checkbox,
  Col,
  Typography,
  Input,
  notification,
  Space,
  Button,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import { FC, useEffect, useState } from "react";
import Table, { ColumnsType } from "antd/es/table";

import {
  allUserPermissionsData,
  IPermission,
  IPermissionActionType,
  IPermissionTableColumnType,
} from "./UserPermissionCommonData";
import TextArea from "antd/es/input/TextArea";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTheme } from "../../Context/ThemeContext";
import CustomerRoleServices from "../../Services/CustomerRoleServices";
import { useUser } from "../../../Context/UserContext";

const AddCustomerRoles: FC<{
  open: boolean;
  onCancel: any;
  id?: string;
  setTrigger?: any;
  setNewItem?: any;
  itemPage?: any;
  isServicesItem?: boolean;
}> = (props) => {
  console.log("props", props);
  const [form] = Form.useForm();
  const { getUserId } = useUser();
  const [permissions, setPermissions] = useState<string[]>([]);
  // "Master.Client.View",
  const [isPermissionErr, setIsPermissionErr] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const { themeData } = useTheme();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);

  // ------- Edit role get Api --------
  useEffect(() => {
    if (props.id) {
      const getRoleData = async () => {
        setDrawerLoading(true);
        await CustomerRoleServices.getRoleById(getUserId()!, props?.id)
          .then((res) => {
            if (res?.status) {
              console.log("res.resulttt", res.result);
              const data = res?.result;

              form.setFieldsValue({
                ...data,
                title: data.title,
                description: data.description,
              });
              setPermissions(data?.accessSettings);
            } else {
              console.log(res);
            }
          })
          .catch((ex) => {
            console.log(ex);
          })
          .finally(() => {
            setDrawerLoading(false);
          });
      };
      getRoleData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.id]);

  const onClose = () => {
    props.onCancel();
    props.setTrigger((x: any) => !x);
    setIsPermissionErr(false);
    form.resetFields();
    setPermissions([]);
  };

  // post customer role api
  const addCustomerPermission = () => {
    try {
      form.validateFields().then(async (val) => {
        let userPermission = {
          ...val,
          accessSettings: permissions,
        };
        if (permissions?.length > 0) {
          setSaveButtonLoading(true);
          setIsPermissionErr(false);
          const postData = await CustomerRoleServices.postCustomerRole(
            getUserId()!,
            userPermission,
            props?.id
          );
          if (postData.status) {
            onClose();
            notification.success({
              message: `Role ${props.id ? "updated" : "saved"} successfully`,
            });
          } else {
            notification.success({
              message: `${postData.message}`,
            });
          }
        } else {
          setIsPermissionErr(true);
        }
      });
    } catch (error: any) {
      notification.success({
        message: "Error",
        description: error || "An error occurred while saving.",
      });
      setIsPermissionErr(permissions?.length > 0 ? false : true);
    } finally {
      setSaveButtonLoading(false);
    }
  };

  const getTableColumns = (
    type: IPermissionTableColumnType,
    disable?: boolean
  ): ColumnsType<IPermission> => {
    let columns: ColumnsType<IPermission> = [
      {
        title: "S.No.",
        key: "sno",
        width: "70px",
        render: (_, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Feature",
        key: "feature",
        ellipsis: { showTitle: false },
        render: (_, record) => (
          <Row align="middle" wrap={false}>
            {type !== IPermissionTableColumnType.View && (
              <Col flex="24px">
                <Checkbox
                  checked={record?.actionType
                    ?.map((itm) => `${record?.featureValue}.${itm}`)
                    ?.every((s) => permissions.includes(s))}
                  onChange={(e) =>
                    onChange(
                      "featureModule",
                      e.target.checked,
                      null,
                      record,
                      null
                    )
                  }
                ></Checkbox>
              </Col>
            )}
            <Col flex="auto">
              <Typography.Text ellipsis={{ tooltip: true }}>
                {record?.feature}
              </Typography.Text>
            </Col>
          </Row>
        ),
      },
      {
        title: "View",
        key: "view",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.View) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.View}`
              )}
              disabled={disable}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.View
                )
              }
            ></Checkbox>
          ) : null,
      },
    ];

    if (
      type === IPermissionTableColumnType.ViewCreate ||
      type === IPermissionTableColumnType.CRED ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Add",
        key: "add",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Add) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Add}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Add
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.ViewUpdate ||
      type === IPermissionTableColumnType.CRED ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Edit",
        key: "edit",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Edit) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Edit}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Edit
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.All ||
      type === IPermissionTableColumnType.CRED
    ) {
      columns.push({
        title: "Delete",
        key: "delete",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Delete) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Delete}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Delete
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.Print ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Print",
        key: "print",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Print) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Print}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Print
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.Authorize ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Authorize",
        key: "authorize",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Authorize) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Authorize}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Authorize
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    return columns;
  };

  console.log(
    "permissions",
    // permissionType,
    // allUserPermissionsData,
    // record
    permissions
  );

  const onChange = (
    type: "allFeature" | "module" | "featureModule" | "feature",
    isChecked: boolean,
    module: string | null,
    record: IPermission | null,
    permissionType: string | null
  ) => {
    let data: any = permissions;

    // console.log(
    //   "permissions",
    //   type,
    //   // permissionType,
    //   // allUserPermissionsData,
    //   // record
    //   permissions
    // );

    switch (type) {
      case "allFeature":
        data = [];
        if (isChecked) {
          for (let i = 0; i <= allUserPermissionsData?.length - 1; i++) {
            data.push(
              allUserPermissionsData[i]?.permissions
                ?.map((itm) => {
                  return itm.actionType.map(
                    (action) => `${itm.featureValue}.${action}`
                  );
                })
                .flat()
            );
          }
          data = data?.flat();
        }

        break;

      case "module":
        let modulePermission = allUserPermissionsData
          ?.find((itm) => itm?.module === module)
          ?.permissions?.map((itm) => {
            return itm.actionType.map(
              (action) => `${itm.featureValue}.${action}`
            );
          })
          .flat();

        console.log("modulePermission", module, modulePermission);

        if (modulePermission?.length && modulePermission?.length > 0) {
          data.push(modulePermission?.flat()?.map((itm) => itm));
          data = data?.flat();

          // console.log("modulePermission data", data);
        }
        if (!isChecked)
          data = data?.filter((itm: any) => !modulePermission?.includes(itm));
        // console.log("modulePermission data 111", data);

        break;

      case "featureModule":
        let featurePermission = record?.actionType?.map(
          (itm) => `${record?.featureValue}.${itm}`
        );
        if (isChecked) {
          // if (!data?.includes(`${record?.module}.View`)) {
          //   data.push(`${record?.module}.View`);
          // }
          data.push(featurePermission?.map((itm) => itm));

          data = data?.flat();
        } else {
          data = data?.filter(
            (item: any) => !featurePermission?.includes(item)
          );
          // if (!data?.includes(`${record?.module}.View`)) {
          let modulePermission = allUserPermissionsData
            ?.find((itm) => itm?.module === record?.module)
            ?.permissions?.map((itm) => {
              return itm.actionType.map(
                (action) => `${itm.featureValue}.${action}`
              );
            })
            .flat();

          if (modulePermission?.length && modulePermission?.length > 0) {
            data = data?.filter((itm: any) => !modulePermission?.includes(itm));
          }
          // }
        }

        break;

      case "feature":
        var item = `${record?.featureValue}.${permissionType}`;
        // var moduleViewPermission = `${record?.module}.View`;
        var viewPermission = `${record?.featureValue}.View`;
        var otherPermission = [
          `${record?.featureValue}.Add`,
          `${record?.featureValue}.Edit`,
          `${record?.featureValue}.Delete`,
          `${record?.featureValue}.Print`,
          `${record?.featureValue}.Authorize`,
        ];
        // console.log(
        //   "item",
        //   item,
        //   "--------",
        //   "moduleViewPermission",
        //   moduleViewPermission,
        //   "---------",
        //   "viewPermission",
        //   viewPermission,
        //   "--------------",
        //   "otherPermission",
        //   otherPermission,
        //   "--------------",
        //   isChecked,
        //   "------------",
        //   permissions
        // );
        if (isChecked) {
          // if (!permissions?.includes(moduleViewPermission))
          //   data.push(moduleViewPermission);

          if (
            // moduleViewPermission !== viewPermission &&
            !permissions?.includes(viewPermission)
          )
            data.push(viewPermission);

          // if (item !== moduleViewPermission && item !== viewPermission)
          if (item !== viewPermission) data.push(item);
        } else {
          if (item === viewPermission) {
            otherPermission.push(viewPermission);
            data = data?.filter(
              (element: any) => !otherPermission.includes(element)
            );
          } else {
            if (
              data?.find((itm: any) => itm?.split(".")[0] === record?.module) ||
              data?.find((itm: any) => itm?.split(".")[1] === record?.module)
            )
              data = data?.filter((i: any) => i !== item);
          }
          if (item === viewPermission) {
            let modulePermission = allUserPermissionsData
              ?.find((itm) => itm?.module === record?.module)
              ?.permissions?.map((itm) => {
                return itm.actionType.map(
                  (action) => `${itm.featureValue}.${action}`
                );
              })
              .flat();

            if (modulePermission?.length && modulePermission?.length > 0) {
              data = data?.filter(
                (itm: any) => !modulePermission?.includes(itm)
              );
            }
          }
        }

        break;
    }

    data = data?.filter(
      (value: any, index: number, self: any) => self.indexOf(value) === index
    );
    setPermissions(data);
    setIsPermissionErr(data?.length > 0 ? false : true);
  };

  const isSelectAllPemissions = () => {
    let totalPermission = 0;
    for (let i = 0; i <= allUserPermissionsData?.length - 1; i++) {
      totalPermission += allUserPermissionsData[i]?.permissions
        ?.map((itm) => {
          return itm.actionType.map(
            (action) => `${itm.featureValue}.${action}`
          );
        })
        .flat()?.length;
    }

    return permissions?.length > 0 && totalPermission === permissions?.length;
  };

  const isModuleSelectAll = (module: string) => {
    let data: any = [];
    let modulePermission = allUserPermissionsData?.find(
      (itm) => itm?.module === module
    );
    if (modulePermission) {
      data.push(
        modulePermission?.permissions
          ?.map((itm) => {
            return itm.actionType.map(
              (action) => `${itm.featureValue}.${action}`
            );
          })
          .flat()
      );
    }
    data = data?.flat();

    return (
      permissions?.length > 0 &&
      data?.every((d: string) => permissions?.includes(d))
    );
  };

  // console.log("premission", permissions);

  const tabsItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: (
        <div>
          {allUserPermissionsData?.slice(0, 1)?.map((itm, idx: number) => (
            <div className="mb-2">
              <Row justify="space-between" align="middle">
                <Col className="fs-14">{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "2",
      label: "Voucher",
      children: (
        <div>
          {allUserPermissionsData?.slice(1, 8)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "3",
      label: "Report",
      children: (
        <div>
          {allUserPermissionsData?.slice(8, 9)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "4",
      label: "Master",
      children: (
        <div>
          {allUserPermissionsData?.slice(9, 17)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType, itm?.disable)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "5",
      label: "Setting",
      children: (
        <div>
          {allUserPermissionsData?.slice(17, 32)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <Drawer
      maskClosable={false}
      open={props.open}
      title={!props?.id ? "Add Role" : "Edit Role"}
      width={950}
      closable={false}
      extra={
        <Space>
          <CloseOutlined onClick={() => props.onCancel()} />
        </Space>
      }
      footer={
        <div style={{ marginTop: "0px" }}>
          <Space
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: 20,
            }}
          >
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => addCustomerPermission()}
              loading={saveButtonLoading}
              // style={{marginLeft:"10px"}}
            >
              {!props?.id ? "Save" : "Update"}
            </Button>
          </Space>
        </div>
      }
      className="ledgerdrawerstyle"
    >
      <Spin indicator={antIcon} spinning={drawerLoading}>
        <Form
          form={form}
          name="rolePermission"
          labelAlign="left"
          labelCol={{ xs: 8, sm: 6 }}
          wrapperCol={{ xs: 16, sm: 18 }}
          colon={false}
          autoComplete="off"
          requiredMark={true}
        >
          <Row gutter={[8, 8]}>
            <Col xs={24} md={18} lg={12} xl={12}>
              <Form.Item
                label="Role"
                name="name"
                rules={[
                  { required: true, message: "This field is required" },
                  // { validator: Utils.validateWhiteSpace },
                ]}
                className="input-item"
              >
                <Input
                  placeholder="Enter role"
                  onKeyPress={(e) =>
                    !/[A-Za-z\s]/.test(e.key) && e.preventDefault()
                  }
                />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
                className="input-item"
              >
                <TextArea placeholder="Enter role description" />
              </Form.Item>
            </Col>
          </Row>

          <Row
            align="middle"
            justify="space-between"
            style={{
              backgroundColor: "#f4f5fa",
              margin: "0px -24px 0px -24px",
              padding: "8px 24px",
              minHeight: 33,
            }}
            className="fw-500"
          >
            <Col className="theme-color">
              <Row align="middle">
                <Col className="fw-600" style={{ paddingRight: "10px" }}>
                  Permissions
                </Col>
                {isPermissionErr && (
                  <Tag color="error">Please choose at least one permission</Tag>
                )}
              </Row>
            </Col>
            <Checkbox
              style={{ fontWeight: 400 }}
              checked={isSelectAllPemissions()}
              onChange={(e) =>
                onChange("allFeature", e.target.checked, null, null, null)
              }
            >
              Select All
            </Checkbox>
          </Row>

          <div
            style={{ maxHeight: "calc(100vh - 304px)", overflow: "auto" }}
            className="custom-scroll"
          >
            <Tabs className="no-margin-left" items={tabsItems} />
          </div>
        </Form>
      </Spin>
    </Drawer>
  );
};
export default AddCustomerRoles;
